import { useEffect,useState } from "react";
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiRequest } from "@/network/apiClient";

export const useLeadInventorySharkTank = (page, pageSize, selectedStatus, filters, searchName, selectedPipelineStage) => {
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalLeads, setTotalLeads] = useState(0);
    const [leadStatusCount, setLeadStatusCount] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [absoluteTotal, setAbsoluteTotal] = useState(0);
    const [pipelineStageCount, setPipelineStageCount] = useState([]);
    const leadStatuses = [];
    const pipelineStages = [];

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const queryParams = new URLSearchParams({
                page: page.toString(),
                page_size: pageSize.toString(),
            })
            // Add filters to the query parameters
            // Handle lead status selection 
            if(selectedStatus) {
                leadStatuses.push(selectedStatus)
            }
            if (filters?.leadStatus?.length) {
                leadStatuses.push(...filters.leadStatus)
            }
            leadStatuses.forEach(status => {
                queryParams.append("lead_status", status);
            });
            // Handle name search
            if(searchName){
                queryParams.append("name", searchName);
            }
            // Handle product selection
            if (filters?.products?.length) {
                filters.products.forEach(product => {
                    queryParams.append("products", product);
                });
            }
            // Handle pipeline stage (status) selection
            if (selectedPipelineStage) {
                if(selectedPipelineStage.length === 1){
                    pipelineStages.push(selectedPipelineStage)
                }else{
                    pipelineStages.push(...selectedPipelineStage)
                }
            }
            if (filters?.pipelineStage?.length) {
                pipelineStages.push(...filters.pipelineStage)
            }
            pipelineStages.forEach(stage => {
                queryParams.append("status", stage);
            });
            // Handle lead source selection
            if (filters?.leadSource?.length) {
                filters.leadSource.forEach(source => {
                    queryParams.append("lead_source", source);
                });
            }
            // Handle interest level selection
            if (filters?.interestLevel?.length) {
                filters.interestLevel.forEach(level => {
                    queryParams.append("interest_level", level);
                });
            }
            // Handle region selection
            if (filters?.region?.length) {
                filters.region.forEach(region => {
                    queryParams.append("region", region);
                });
            }
            if (filters?.hunterId?.length) {
                filters.hunterId.forEach(hunter => {
                    queryParams.append("hunter_id", hunter)
                })
            }
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_LEADS.SHARK_TANK}?${queryParams.toString()}`, 'GET')

            setData(result.data);
            setTotalPages(result.total_pages);
            setTotalLeads(result.total_rows);
            setLeadStatusCount(result.lead_status_count);
            setAbsoluteTotal(result.absolute_total);
            setPipelineStageCount(result.pipeline_stage_count);
            setIsLoading(false);
            
        } catch (error) {
            setIsLoading(false);
        }
    };

    useEffect(() => {        
        fetchData();
    }, [page, pageSize, selectedStatus, filters, searchName, selectedPipelineStage]);

    return { data, totalPages, totalLeads, leadStatusCount, isLoading, absoluteTotal, pipelineStageCount, refetch: fetchData };
};
